import { ActionIcon, Button, Divider, Grid, Group, Menu, Modal, Paper, Text, Title, Tooltip } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React, { useEffect } from 'react';
import { FaEnvelope, FaEllipsisV, FaHome, FaPencilAlt, FaPlus, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import InputField, { InputFieldTypes } from '../components/input_field';
import SimpleHeader from '../components/simple_header';
import { useApp } from '../contexts/app.context';
import { DELETE_TRIGGER, GET_ALL_TRIGGERS, SAVE_TRIGGER, SAVE_TRIGGER_ACTION } from '../services/triggers';

const triggersTypes = [
    { value: "device-moves", label: "Veículo - Localização atualizada" },
    { value: "device-fuel", label: "Veículo - Nível do combustível" },
    { value: "device-power", label: "Veículo - Ligado ou desligado" },
    { value: "device-speed", label: "Veículo - Velocidade" },
]
const deviceSpeedComparisonsTypes = [
    { label: "Igual à", value: "eq" },
    { label: "Diferente de", value: "diff" },
    { label: "Maior que", value: "gt" },
    { label: "Maior ou igual à", value: "gte" },
    { label: "Menor que", value: "lt" },
    { label: "Menor ou igual à", value: "lte" },
]
const devicePowerWhenOptions = [
    { label: "Ao ligar", value: "on" },
    { label: "Ao desligar", value: "off" },
    { label: "Ao desligar ou ligar", value: "on-off" },
]
const actionsTypes = [
    { label: "Enviar e-mail", value: "send-mail" },
]

export default function TriggersPage(){
    const [items, setItems] = React.useState<any[]>([]);
    const [modal, setModal] = React.useState<any>(null);
    const [addingAction, setAddingAction] = React.useState<any>(null);
    const [loadingItems, setLoadingItems] = React.useState<boolean>(false);
    const [loadingDelete, setLoadingDelete] = React.useState({});

    const app = useApp();
    const navigate = useNavigate();

    const loadItems = () => {
        setLoadingItems(true)
        GET_ALL_TRIGGERS()
        .then(res => {
            setItems(res);
            setLoadingItems(false)
        })
        .catch(err => {
            setLoadingItems(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }
    
    const deleteItem = (triggerId) => {
        setLoadingDelete(ld => ({...ld, [`${triggerId}`]: true}))
        DELETE_TRIGGER(triggerId)
        .then(res => {
            setLoadingDelete(ld => ({...ld, [`${triggerId}`]: false}))
            loadItems()
        })
        .catch(err => {
            setLoadingDelete(ld => ({...ld, [`${triggerId}`]: false}))
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    useEffect(loadItems, []);

    return <>
        <SimpleHeader title="Automações" button={{leftIcon: <FaPlus />, title: "Automação", onClick: () => { setModal(true)}}}  />
        
        <Grid>
            {items.map((item, i) => (
                <Grid.Col xs={12} md={3}>
                    <Paper shadow='xs' p="md">
                        <Group align='flex-start'>
                            <Title weight="normal" style={{flex: 1}} order={5}>{triggersTypes.find(tt => tt.value === item.event_type)?.label}</Title>
                            <Menu>
                                <Menu.Target>
                                    <ActionIcon variant="light"><FaEllipsisV /></ActionIcon>
                                </Menu.Target>
                                <Menu.Dropdown style={{minWidth: 140}}>
                                    <Menu.Item
                                        color={"blue"}
                                        icon={<FaPencilAlt />}
                                        onClick={() => { setModal(item) }}
                                    >Editar</Menu.Item>
                                    <Menu.Item
                                        color={"red"}
                                        icon={<FaTrash />}
                                        onClick={() => {
                                            app.confirmDialog(
                                                {text: "Realmente deseja deletar?"},
                                                (({confirmed}) => {
                                                    if(confirmed) deleteItem(item._id);
                                                })
                                            )
                                        }}
                                    >Deletar</Menu.Item>
                                </Menu.Dropdown>
                            </Menu>
                        </Group>
                        <Divider mt="xs" mb="xs" />
                        {item.event_type === "device-power" && <Group>
                            <Text color="gray" size="sm">{devicePowerWhenOptions.find(ct => ct.value === item.props.when)?.label}</Text>
                        </Group>}
                        {item.event_type === "device-speed" && (item.props?.comparisons || []).map(comparison => <Group>
                            <Text color="gray" size="sm">{deviceSpeedComparisonsTypes.find(ct => ct.value === comparison.type_comparison)?.label} {comparison.value}</Text>
                        </Group>)}
                        <Divider mt="xs" mb="xs" />
                        <Group>
                            {(item.actions || []).map(act => (
                                <ActionIcon color="orange" size="lg" variant='filled' onClick={() => setAddingAction({ triggerId: item._id, data: act })}><FaEnvelope /></ActionIcon>
                            ))}
                            <Tooltip label="Adicionar ação" position='bottom'>
                                <ActionIcon color="orange" size="lg" variant='light' onClick={() => setAddingAction({ triggerId: item._id })}><FaPlus /></ActionIcon>
                            </Tooltip>
                        </Group>
                    </Paper>
                </Grid.Col>
            ))}
        </Grid>

        <TriggerModal
            data={modal}
            opened={!!modal}
            onClose={() => setModal(null)}
            onSave={() => { loadItems(); setModal(null) }}
        />
        <ActionModal
            data={addingAction?.data}
            triggerId={addingAction?.triggerId}
            opened={!!addingAction}
            onClose={() => setAddingAction(null)}
            onSave={() => { loadItems(); setAddingAction(null) }}
        />
    </>
}

const TriggerModal = (props) => {
    const { data : dataParent = null, onClose, onSave, opened = false } = props;
    const [loadingSave, setLoadingSave] = React.useState<boolean>(false);
    const [data, setData] = React.useState<any>(null);

    const handleChange = dt => setData(d => ({...d, ...dt}));
    const handleChangeProps = dt => setData(d => ({...d, props: { ...d?.props, ...dt }}));
    const handleChangePropsComparison = index => dt => {
        setData(d => ({...d, props: {
            ...d?.props, comparisons: (d?.props?.comparisons || []).map((c, i) => (
                index === i ? { ...c, ...dt } : c
            )),
        }}))
    };

    const handleSave = () => {
        setLoadingSave(true)
        SAVE_TRIGGER({ ...data, id: dataParent?._id })
        .then(() => {
            setLoadingSave(false)
            onSave && onSave();
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    useEffect(() => {
        if(opened) setData({...dataParent})
    }, [opened, dataParent])

    return <>
        <Modal
            opened={!!opened}
            onClose={onClose}
            size="lg"
            styles={{content: {minHeight: 500}}}
        >
            <InputField
                mb="lg"
                name="event_type"
                title="Tipo do evento"
                fieldType={InputFieldTypes.SELECT}
                options={triggersTypes}
                value={data?.event_type}
                onChange={handleChange}
            />

            {data?.event_type === "device-power" && <>
                <Group grow mb="lg">
                    <InputField
                        name="when"
                        title="Quando"
                        fieldType={InputFieldTypes.SELECT}
                        options={devicePowerWhenOptions}
                        value={data?.props?.when}
                        onChange={handleChangeProps}
                    />
                </Group>
            </>}
            {data?.event_type === "device-speed" && <>
                <Text>Velocidades</Text>
                {(data.props?.comparisons || []).map((comparison, cIndex) => <Group grow mb="lg">
                    <InputField
                        name="type_comparison"
                        title="Tipo"
                        fieldType={InputFieldTypes.SELECT}
                        options={deviceSpeedComparisonsTypes}
                        value={comparison.type_comparison}
                        onChange={handleChangePropsComparison(cIndex)}
                    />
                    <InputField
                        name="value"
                        title="Valor (km/h)"
                        value={comparison.value}
                        onChange={handleChangePropsComparison(cIndex)}
                    />
                </Group>)}
                <Group position='right' mb="lg">
                    <Button size="xs" color="orange" variant="subtle" onClick={() => {
                        setData(d => ({
                            ...d,
                            props: {...d?.props, comparisons: [...(d?.props?.comparisons || []), {}]}
                        }))
                    }}>Adicionar comparação</Button>
                </Group>
            </>}

            <Group position='right'>
                <Button variant='subtle' disabled={loadingSave} onClick={onClose}>Cancelar</Button>
                <Button variant='filled' loading={loadingSave} onClick={handleSave}>Salvar</Button>
            </Group>
        </Modal>
    </>
}

const ActionModal = (props) => {
    const { data : dataParent = null, triggerId, onClose, onSave, opened = false } = props;
    const [loadingSave, setLoadingSave] = React.useState<boolean>(false);
    const [data, setData] = React.useState<any>(null);

    const handleChange = dt => setData(d => ({...d, ...dt}));
    const handleChangeProps = dt => setData(d => ({...d, props: { ...d?.props, ...dt }}));

    const handleSave = () => {
        setLoadingSave(true)
        SAVE_TRIGGER_ACTION(triggerId, { ...data, id: dataParent?._id })
        .then(() => {
            setLoadingSave(false)
            onSave && onSave();
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    useEffect(() => {
        if(opened) setData({...dataParent})
    }, [opened, dataParent])

    return <>
        <Modal
            opened={!!opened}
            onClose={onClose}
            size="lg"
            styles={{content: {minHeight: 500}}}
        >
            <InputField
                mb="lg"
                name="type"
                title="Ação"
                fieldType={InputFieldTypes.SELECT}
                options={actionsTypes}
                value={data?.type}
                onChange={handleChange}
            />

            {data?.type === "send-mail" && <>
                <Group grow mb="lg">
                    <InputField
                        name="to"
                        title="Para"
                        value={data?.props?.to}
                        onChange={handleChangeProps}
                    />
                </Group>
                <Group grow mb="lg">
                    <InputField
                        name="subject"
                        title="Assunto"
                        value={data?.props?.subject}
                        onChange={handleChangeProps}
                    />
                </Group>
                <Group grow mb="lg">
                    <InputField
                        name="body"
                        title="Corpo do e-mail"
                        fieldType={InputFieldTypes.TEXTAREA}
                        value={data?.props?.body}
                        onChange={handleChangeProps}
                    />
                </Group>
            </>}
            

            <Group position='right'>
                <Button variant='subtle' disabled={loadingSave} onClick={onClose}>Cancelar</Button>
                <Button variant='filled' loading={loadingSave} onClick={handleSave}>Salvar</Button>
            </Group>
        </Modal>
    </>
}